import * as React from "react";
import { Scope, Checkbox, useFieldApi } from "informed";
import { SelectedFixedComment, SelectedFixedCommentMeta } from "../../../../misc/api/FixedComments/apiTypes";
import { nameof } from "ts-simple-nameof";
import { TextBox } from "../../../../forms/informedv2/TextBox";
import { Required } from "../../../../forms/validation/Required";

interface FixedCommentInputProps {
    field: string;
    fixedComment: SelectedFixedCommentMeta;
    isReadOnly: boolean;
};  

const FixedCommentInput = ({ field, fixedComment, isReadOnly }: FixedCommentInputProps): JSX.Element => {

    const isSelectedField = useFieldApi<boolean>(`${field}.${nameof<SelectedFixedComment>(fc => fc.IsSelected)}`);

    const validateTestComment = (value: string) => {
        const isSelected = isSelectedField.getValue();

        if (isSelected && fixedComment.followOnCommentRequired) {
            return Required(value);
        }

        return undefined;
    };

    const hideFixedComment = (fixedComment: SelectedFixedCommentMeta): boolean => {
        return fixedComment.disabled && !fixedComment.IsSelected;
    };

    return (<Scope scope={field}>
        <div hidden={hideFixedComment(fixedComment)} className={hideFixedComment(fixedComment) ? "" : "checkbox"}>
            <label htmlFor={`tech-comment-${field}`}>
                <Checkbox disabled={fixedComment.disabled || isReadOnly} id={`tech-comment-${field}`} field={nameof<SelectedFixedComment>(fc => fc.IsSelected)} />
                {fixedComment.comment}
            </label>
        </div>
        <div hidden={hideFixedComment(fixedComment) || (!isSelectedField.getValue() || !fixedComment.followOnCommentAvailable)}>
            <label htmlFor={`comment-annotation-${field}`}>{fixedComment.followOnCommentAnnotation}</label>
            <TextBox disabled={fixedComment.disabled || isReadOnly} id={`comment-annotation-${field}`} field={nameof<SelectedFixedComment>(fc => fc.FollowOnComment)} validate={validateTestComment} />
        </div>
    </Scope>);
};

export default FixedCommentInput;
